import { useState } from "react";
import axios from "axios";
import { Loader2 } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function Admin() {
  const [key, setKey] = useState(sessionStorage.getItem("omk_admin_key") || "");
  const [enquiries, setEnquiries] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const load = async (k) => {
    setLoading(true);
    setError("");
    try {
      const res = await axios.get(`${API}/enquiries`, { headers: { "X-Admin-Key": k } });
      setEnquiries(res.data);
      sessionStorage.setItem("omk_admin_key", k);
    } catch {
      setError("Invalid admin key.");
      setEnquiries(null);
    } finally {
      setLoading(false);
    }
  };

  return (
    <section className="mx-auto max-w-[1200px] px-6 pb-28 pt-40 lg:px-12" data-testid="admin-page">
      <p className="font-mono-label text-xs text-copper">Internal</p>
      <h1 className="font-display mt-4 text-4xl font-semibold uppercase text-zinc-100 sm:text-5xl">Buyer enquiries</h1>

      {enquiries === null && (
        <form
          onSubmit={(e) => { e.preventDefault(); load(key); }}
          className="mt-10 flex max-w-md gap-3"
          data-testid="admin-key-form"
        >
          <input
            type="password"
            value={key}
            onChange={(e) => setKey(e.target.value)}
            placeholder="Admin key"
            className="w-full border border-zinc-700 bg-surface px-4 py-3 text-sm text-zinc-100 outline-none transition-colors duration-300 focus:border-copper"
            data-testid="admin-key-input"
          />
          <button type="submit" className="bg-copper px-6 py-3 font-mono-label text-xs text-ink transition-colors duration-300 hover:bg-copper-light" data-testid="admin-login-btn">
            View
          </button>
        </form>
      )}
      {error && <p className="mt-4 font-mono text-sm text-red-400" data-testid="admin-error">{error}</p>}
      {loading && <Loader2 className="mt-10 animate-spin text-copper" data-testid="admin-loading" />}

      {enquiries !== null && (
        <div className="mt-10 space-y-4" data-testid="admin-enquiries-list">
          <p className="font-mono text-xs text-zinc-500" data-testid="admin-count">{enquiries.length} enquiry(ies)</p>
          {enquiries.length === 0 && <p className="text-sm text-zinc-500">No enquiries yet.</p>}
          {enquiries.map((q) => (
            <div key={q.id} className="border border-zinc-800 bg-surface p-6" data-testid={`admin-enquiry-${q.id}`}>
              <div className="flex flex-wrap items-baseline justify-between gap-2">
                <p className="font-display text-lg font-medium uppercase text-zinc-100">{q.name} {q.company && `— ${q.company}`}</p>
                <span className="font-mono-label text-[10px] text-copper">{q.product}</span>
              </div>
              <p className="mt-2 font-mono text-xs text-zinc-400">
                {q.email} {q.phone && `· ${q.phone}`} {q.country && `· ${q.country}`} {q.quantity && `· ${q.quantity}`}
              </p>
              {q.message && <p className="mt-3 text-sm text-zinc-400">{q.message}</p>}
              <p className="mt-3 font-mono text-[10px] text-zinc-600">{new Date(q.created_at).toLocaleString()}</p>
            </div>
          ))}
        </div>
      )}
    </section>
  );
}
